import { Redirect } from 'expo-router';
import {
    BananaIcon,
    ChartBarBigIcon,
    CloudSunIcon,
    CreditCardIcon,
    MapIcon,
    MicrowaveIcon,
    NavigationRow,
    PlayIcon,
    RowList,
    ScreenContainer,
    UserPlusIcon,
    YStack,
} from 'smoothie';

export default function DevIndexPage() {
    // Use process.env directly (not IS_PRODUCTION) so the bundler can
    // dead-code-eliminate this component from production builds.
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <ScreenContainer title="Dev Pages" hasBackButton onFallbackRoute="/">
            <YStack gap={32}>
                <RowList width="100%" marginTop={8}>
                    <NavigationRow
                        title="Blender Gallery"
                        subtitle="Browse Smoothie components in the design system gallery."
                        leftIcon={BananaIcon}
                        href="/dev/design-system"
                    />
                    <NavigationRow
                        title="Quick Switcher"
                        subtitle="Create test users, add credentials, and switch sessions."
                        leftIcon={UserPlusIcon}
                        href="/dev/quick-switcher"
                    />
                    <NavigationRow
                        title="New Member Creation Flow"
                        subtitle="Start the production-like flow for creating a new member."
                        leftIcon={UserPlusIcon}
                        href="/dev/conv-mm-account-form"
                    />
                </RowList>
                <RowList width="100%">
                    <NavigationRow
                        title="Conversational MM"
                        subtitle="Test out conversational MM pre-signup."
                        leftIcon={MicrowaveIcon}
                        href="/sign-up/get-started"
                    />
                    <NavigationRow
                        title="Canned CMM signup"
                        subtitle="Pick a canned CMM scenario, then create an account."
                        leftIcon={MicrowaveIcon}
                        href="/dev/cmm-scenario"
                    />
                    <NavigationRow
                        title="Money Map Visual Gallery"
                        subtitle="Test both variants, scenarios, and selection animations."
                        leftIcon={ChartBarBigIcon}
                        href="/dev/money-map/money-map-visual-gallery"
                    />
                    <NavigationRow
                        title="Money Map Simulator"
                        subtitle="Simulate money flow through a Money Map over time."
                        leftIcon={MapIcon}
                        href="/dev/money-map/money-map-simulator"
                    />
                    <NavigationRow
                        title="Aha Moment Playground"
                        subtitle="Edit JSON and preview the onboarding results carousel."
                        leftIcon={PlayIcon}
                        href="/dev/money-map/conversational-mm-playground"
                    />
                    <NavigationRow
                        title="Weather Agent"
                        subtitle="Chat with the example weather agent for llm-service QA."
                        leftIcon={CloudSunIcon}
                        href="/dev/weather-agent"
                    />
                    <NavigationRow
                        title="Upgrade to Premium (POC)"
                        subtitle="Trial -> Premium upgrade flow, wired to the real backend."
                        leftIcon={CreditCardIcon}
                        href="/dev/stripe/upgrade-comparison"
                    />
                    <NavigationRow
                        title="Manage Payment Method (POC)"
                        subtitle="Add / change payment method flow, wired to the real backend."
                        leftIcon={CreditCardIcon}
                        href="/dev/stripe/payment-method"
                    />
                </RowList>
            </YStack>
        </ScreenContainer>
    );
}
